<!-- 零售详情 - 虚拟发货 -->
<template>
  <div class="VirtuallySendGoods cus-modal" v-loading="loading">
    <OmsForm :form-config="formConfig" />
    <OmsButton class="modal-footer" :btn-config="btnConfig" />
  </div>
</template>

<script>
const { network, urlSearchParams } = R3;
export default {
  name: 'VirtuallySendGoods',
  props: {
    componentData: {},
  },
  watch: {
    componentData: {
      handler(newObj) {
        this.formConfig.formValue = Object.assign({}, this.formConfig.formValue, _.cloneDeep(newObj));
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      loading: false,
      btnConfig: {
        typeAll: 'default',
        btnsite: 'right',
        buttons: [
          {
            text: t('取消'),
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            },
          },
          {
            type: 'primary', // 按钮类型
            text: t('确定'),
            btnclick: () => {
              this.datermine();
            }, // 按钮点击事件
          },
        ],
      },
      formConfig: {
        formValue: {
          billNo: '',
          tid: '',
          ptShopName: '',
          orderId: '',
          cpCLogisticsId: '',
          expressCode: '',
        },
        ruleValidate: {
          expressCode: [{ required: true, message: ' ', trigger: 'blur' }],
        },
        formData: [
          {
            style: 'input',
            label: t('单据编号'), // 单据编号
            value: 'billNo',
            width: '8',
            disabled: true,
          },
          {
            style: 'input',
            label: t('平台单号'), // 平台单号
            value: 'tid',
            width: '8',
            disabled: true,
          },
          {
            style: 'input',
            label: t('平台店铺'), // 平台店铺
            value: 'ptShopName',
            width: '8',
            disabled: true,
          },
          {
            style: 'dropSelect',
            width: '8',
            class: 'cpCLogisticsId',
            dataAcessKey: 'cpCLogisticsId',
            itemdata: {
              colid: 168212,
              colname: 'cpCLogisticsId',
              fkdisplay: 'drp',
              isfk: true,
              isnotnull: false,
              name: t('物流公司'), // 物流公司
              readonly: false,
              valuedata: '',
              pid: '',
              defaultSelectedMrp: [],
            },
            oneObj: (e) => {
              this.formConfig.formValue.cpCLogisticsId = e.pid || '';
            },
          },
          {
            style: 'input',
            label: t('物流单号'), // 物流单号
            value: 'expressCode',
            width: '8',
          },
        ],
      },
    };
  },
  async mounted() {
    const {
      data: { code, message, data },
    } = await this.service.common
      .publicUrlParams('/api/cs/oc/oms/v1/virtuallySend/init', {
        id: vm.$route.params.customizedModuleId,
      })
      .catch(() => {
        this.loading = false;
      });
    if (code == 0) {
      this.formConfig.formValue = Object.assign({}, this.formConfig.formValue, _.cloneDeep(data));
    }
  },
  methods: {
    async datermine() {
      if (!this.formConfig.formValue.expressCode) {
        this.$Message.error(t('请填写物流单号！'));
        return;
      }
      let params = _.cloneDeep(this.formConfig.formValue);
      this.loading = true;
      const url = '/api/cs/oc/oms/v1/virtuallySend/confirm';
      const {
        data: { code, message },
      } = await this.service.common.publicUrlParams(url, params).catch(() => {
        this.loading = false;
      });
      this.loading = false;
      if (code === 0) {
        this.$parent.$parent.$parent.autoRefresh();
        this.$parent.$parent.closeConfirm();
        this.$Message.success(message);
      }
    },
  },
};
</script>
